import { PEOPLE_TYPE } from "./types";

export const tabs = [
  { name: "Members", value: PEOPLE_TYPE.MEMBERS },
  { name: "Leads", value: PEOPLE_TYPE.LEADS },
  { name: "Staff", value: PEOPLE_TYPE.STAFF },
];

export const staffRolesFilterOptions = [
  { label: "Admin", value: "admin" },
  { label: "Coach", value: "coach" },
  { label: "Front desk", value: "frontdesk" },
];

export const memberTypesFilterOptions = [
  { label: "Member", value: "member" },
  { label: "Non-member", value: "non-member" },
  { label: "Ex-member", value: "ex-member" },
];

export const memberSubscriptionStatusFilterOptions = [
  { label: "Active", value: "active" },
  { label: "Alert", value: "alert" },
  { label: "Cancelled", value: "cancelled" },
  { label: "Completed", value: "completed" },
  { label: "Paused", value: "paused" },
  { label: "Pending activation", value: "pendactivation" },
  { label: "Pending cancel", value: "pendcancel" },
];

export const leadStatusFilterOptions = [
  { label: "New", value: "new lead" },
  { label: "Attempted", value: "attempted" },
  { label: "Contacted", value: "contacted" },
  { label: "In discussion", value: "in discussion" },
  { label: "Converted", value: "converted" },
  { label: "Disqualified", value: "disqualified" },
];

export const memberChurnDateFilterOptions = [
  { label: "Today", value: "today" },
  { label: "Yesterday", value: "yesterday" },
  { label: "Week to date", value: "week_to_date" },
  { label: "Month to date", value: "month_to_date" },
  { label: "Quarter to date", value: "quarter_to_date" },
  { label: "Year to date", value: "year_to_date" },
  { label: "Last 7 days", value: "last_7_days" },
  { label: "Last 30 days", value: "last_30_days" },
];

export const PAGINATION_PAGE_SIZE = 50;

export const MEMBER_STATUS_VARIANTS = {
  active: "success",
  cancelled: "error",
  alert: "warning",
  default: "neutral",
};

export const LEAD_STATUS_VARIANTS = {
  converted: "success",
  disqualified: "error",
  contacted: "warning",
  "in discussion": "warning",
  default: "neutral",
};

export const NO_REPLY_EMAIL = "no-reply";
